import { useEffect, useState } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { useSelector } from 'react-redux';
import { Prod01 } from '../../constants/ActionType';
import { isSuperAdmin } from './StaffOrgAssign';
import { isPracticeOrg } from '../../utils/patientForm';

// Roles that may pick among their own organizations when they belong to several (mirrors backend ORG_SETTER_ROLES)
export const ORG_SETTER_ROLES = ['admin', 'adminStaff', 'HrLead'];

const OrganizationSelect = ({ value, onChange, label = 'Organization', practiceOnly = false }) => {
  const { user } = useSelector((state) => state.auth);
  const [orgs, setOrgs] = useState([]);
  // Super Admin: any active org. Others: read-only own org unless they are a setter role with several orgs.
  const canSet = isSuperAdmin(user) || (ORG_SETTER_ROLES.includes(user?.role) && orgs.length > 1);

  useEffect(() => {
    let alive = true;
    axios
      .get(`${Prod01}/${practiceOnly ? 'patient/form/organizations' : 'general/organizations'}`)
      .then(({ data: raw }) => {
        if (!alive) return;
        const data = practiceOnly ? (raw || []).filter(isPracticeOrg) : raw;
        setOrgs(data || []);
        if (!isSuperAdmin(user) && data?.length === 1 && !value) onChange(data[0]._id);
      })
      .catch(() => setOrgs([]));
    return () => {
      alive = false;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const options = orgs.map((o) => ({ value: o._id, label: o.name }));
  const selected = options.find((o) => o.value === String(value)) || null;

  return (
    <div>
      <label className="form-label mt-3">
        {label} <span style={{ color: 'red', fontWeight: 'bold' }}> *</span>
      </label>
      <Select
        options={options}
        value={selected}
        isDisabled={!canSet}
        placeholder={canSet ? 'Select organization' : 'Your organization'}
        onChange={(opt) => onChange(opt ? opt.value : '')}
      />
      {!canSet && !selected ? (
        <small className="text-muted">Only a Super Admin can change the organization.</small>
      ) : null}
    </div>
  );
};

export default OrganizationSelect;
